module.exports = __webpack_public_path__ + "pc/img/about_txt.3be0341b.png";